function generalComplexityRule() {
  let generalComplexityRules = [
    {
      test: ({
        password
      }) => {
        return {
          name: 'one lowercase letter',
          pass: (/[a-z]+/).test(password)
        };
      }
    },
    {
      test: ({
        password
      }) => {
        return {
          name: 'one uppercase letter',
          pass: (/[A-Z]+/).test(password)
        };
      }
    },
    {
      test: ({
        password
      }) => {
        return {
          name: 'one number',
          pass: (/[0-9]+/).test(password)
        };
      }
    },
    {
      test: ({
        password
      }) => {
        return {
          name: 'one non-alphanumeric (!, $, #, %, space, etc)',
          pass: (/\W+/).test(password)
        };
      }
    }
  ];

  return {
    rules: generalComplexityRules,
    test: ({
      password
    }) => {
      let subtestResults = generalComplexityRules.map(rule => {
        return rule.test({password: password});
      });

      return {
        name: 'At least 3 of the following:',
        pass:  subtestResults.filter(x => x.pass).length >= 3,
        subtests: subtestResults
      };
    }
  };
}

export default generalComplexityRule;